import React from "react";
import type { ModalViewType } from "../../../../../../common-deprecated/types/CommonTypes";
import ModalBaseView from "../../../styles/organisms/Modal";
import TyreSlider from "./TyreSlider";
import Text from "../../../styles/atoms/Text";
import Icon from "../../../styles/atoms/Icon";
import * as ModalStyles from "../../../styles/organisms/Modal.styles";
import type { TyreInfoModalType } from "../../../../../../shared-logic/utils/tyreInfoContants";

const TyreInfoModal = (props: ModalViewType<TyreInfoModalType>): JSX.Element => {
    const { show, close, modalSettings } = props;
    const { tyres, tyreInfoLabels } = modalSettings;

    return (
        <ModalBaseView modalIdType={modalSettings.type} onClose={close} show={show} size="fitcontent">
            <ModalStyles.Header>
                <Text tag="h2" variant="h4">
                    {tyreInfoLabels.tyreInfo}
                </Text>
                <ModalStyles.Button type="button" onClick={close}>
                    <Icon variant="close" />
                </ModalStyles.Button>
            </ModalStyles.Header>
            <ModalStyles.Body>
                <Text variant="paragraph-body-book">{tyreInfoLabels.tyreInfoDescription}</Text>
                {tyres.length > 0 ? (
                    <TyreSlider tyres={tyres} tyreInfoLabels={tyreInfoLabels} />
                ) : (
                    <Text variant="paragraph-body-book">{tyreInfoLabels.tyreInfoNoEprelFallback}</Text>
                )}
            </ModalStyles.Body>
        </ModalBaseView>
    );
};

export default TyreInfoModal;
